class PackUpsell extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-add-btn]');
    this.label = this.querySelector('[data-btn-label]');
    this.variantEl = this.querySelector('[data-variant-title]');
    if (!this.button) return;

    this.originalLabel = this.label?.textContent?.trim() ?? '';
    this.variantId = this.dataset.variantId;
    this.brandKey = (this.dataset.brandKey || '').toLowerCase();

    try {
      const raw = this.dataset.companionVariants;
      this.companionVariants = raw ? JSON.parse(raw) : [];
    } catch (_e) {
      this.companionVariants = [];
    }

    this.onClick = this.onClick.bind(this);
    this.onVariantUpdate = this.onVariantUpdate.bind(this);
    this.button.addEventListener('click', this.onClick);
    document.addEventListener('variant:update', this.onVariantUpdate);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
    document.removeEventListener('variant:update', this.onVariantUpdate);
  }

  onVariantUpdate(event) {
    // Horizon's VariantUpdateEvent puts the variant object on
    // `event.detail.resource` (see assets/events.js).
    const variant = event?.detail?.resource;
    if (!variant) return;
    const match = this.findMatch(variant.title || variant.option1 || '');
    if (!match) return;
    this.variantId = String(match.id);
    if (this.variantEl) {
      const title = match.title && match.title !== 'Default Title' ? match.title : '';
      this.variantEl.textContent = title;
    }
  }

  tokenize(str) {
    return String(str || '')
      .toLowerCase()
      .split(/[^a-z0-9]+/i)
      .filter((t) => t.length >= 2);
  }

  findMatch(currentTitle) {
    if (!this.companionVariants.length) return null;
    const tokens = this.tokenize(currentTitle);
    let best = null;
    let bestScore = -1;
    for (const v of this.companionVariants) {
      const vTokens = this.tokenize(v.title);
      let score = 0;
      if (this.brandKey && vTokens.includes(this.brandKey)) score += 100;
      for (const t of tokens) {
        if (vTokens.includes(t)) score += 1;
      }
      if (v.available === false) score -= 50;
      if (score > bestScore) {
        bestScore = score;
        best = v;
      }
    }
    return best;
  }

  async onClick(event) {
    event.preventDefault();
    if (!this.variantId) return;
    if (this.button.hasAttribute('disabled')) return;

    this.setState('loading', 'Añadiendo…');

    try {
      const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: parseInt(this.variantId, 10), quantity: 1 }],
        }),
      });

      if (!response.ok) {
        const errorPayload = await response.json().catch(() => ({}));
        throw new Error(errorPayload?.description || `HTTP ${response.status}`);
      }

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { didError: false } },
        })
      );
      document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));

      this.setState('added', 'Añadido ✓');
      setTimeout(() => this.setState('idle'), 2500);
    } catch (err) {
      console.error('[pack-upsell] add failed', err);
      this.setState('error', 'Error — reintenta');
      setTimeout(() => this.setState('idle'), 3500);
    }
  }

  setState(state, labelText) {
    if (state === 'idle') {
      this.removeAttribute('data-state');
      this.button.removeAttribute('disabled');
      if (this.label) this.label.textContent = this.originalLabel;
      return;
    }
    this.setAttribute('data-state', state);
    if (state === 'loading') {
      this.button.setAttribute('disabled', '');
    } else {
      this.button.removeAttribute('disabled');
    }
    if (this.label && labelText) this.label.textContent = labelText;
  }
}

if (!customElements.get('pack-upsell')) {
  customElements.define('pack-upsell', PackUpsell);
}
